import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17.01 18"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16 4.81h-.59c-.22 0-.53.32-.53.52v7.37c0 .2.31.48.53.48H16v1.75h-5.37v-1.75h1.12V5.44h-.05l-2.63 9.5H7.04l-2.59-9.5h-.07v7.75H5.5v1.75H1v-1.75h.58c.24 0 .55-.28.55-.48V5.33c0-.2-.31-.52-.55-.52H1V3.06h5.63l1.85 6.87h.05l1.86-6.87H16v1.75"
    }, null, -1)
  ])))
}
export default { render };